import React from 'react';
import useAnalytics from 'helpers/useAnalytics';
import * as Types from './types';
import _get from 'lodash/get';

import NavListItemBase from './molecules/NavListItemBase';
import ListItemText from './molecules/ListItemText';
import ListItemIcon from './molecules/ListItemIcon';

interface Props {
  item: Types.ExternalLinkNavItem;
  className?: string;
}

function ExternalLinkNavItem({ item, className }: Props) {
  const Icon = _get(item, 'Icon');
  const analytics = useAnalytics();

  const handleSupportItemClick = () => {
    analytics.track('Support Admin Navigation Item clicked', {
      category: 'AD - Navigation',
      label: _get(item, ['header', 'title']),
    });
  };

  return (
    <a
      href={item.link}
      id={item.id}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleSupportItemClick}
    >
      <NavListItemBase className={className}>
        {!!Icon && (
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
        )}
        <ListItemText>{_get(item, ['header', 'title'])}</ListItemText>
      </NavListItemBase>
    </a>
  );
}

export default ExternalLinkNavItem;
